import { Skeleton, Stack } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

export function MarketplaceLoadingState() {
  const { t } = useTranslation();

  return (
    <Stack gap={16} aria-label={t("marketplace.loading")}>
      <Skeleton height={24} width={220} />
      <div className="grid gap-(--spacing-16) md:grid-cols-2 lg:grid-cols-3">
        {["first", "second", "third"].map((position) => (
          <Skeleton key={position} height={220} />
        ))}
      </div>
    </Stack>
  );
}
